<template>
  <div class="content ">
    <div class="page-header " :class="{'header-hidden': !isScrollTop}">
      <div class="flex px-4 md:block">
        <div class="w-64 lg:w-60 px-4 lg:pl-0 pt-5 md:hidden lg:flex-none">
          <img :src="require('../../assets/images/home-monthly-donation.png')" width="200"/>
        </div>

        <div class="mt-6 lg:mt-4 w-3/5 md:w-full">
          <div class="font-semibold text-3xl md:text-xl">Monthly Gifts</div>
          <p class="md:hidden">Learn more about your recurring monthly donations</p>
          <div v-if="subscriptionsLoaded" class="flex justify-between mt-6 lg:mt-3">
            <div class="text-center">
              <span class="font-black text-4xl md:text-xl">{{ activeStatistic.count }}</span>
              <div class="md:text-sm mt-2">Active</div>
            </div>
            <div class="text-center px-5 sm:px3">
              <span
                  class="font-black text-4xl md:text-xl">${{ activeStatistic.amount / 100 | formatMoney }}<small>/mo</small></span>
              <div class="md:text-sm mt-2">Amount per Month</div>
            </div>
            <div class="text-center">
              <span class="font-black text-4xl md:text-xl">${{ analytics.donated / 100 | formatMoney }}</span>
              <div class="md:text-sm mt-2">All-Time Monthly Donations</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <reports-menu
        :start-date="startDate"
        :end-date="endDate"
        :show-date-piker="false"
        v-on:download="download"
        :isSearchBox="true"
        v-model="searchDonorsName"
    >

      <template v-slot:filter>
        <el-radio-group class="capitalize px-8 md:px-4 pt-4" v-model="selectedFilter" >
          <el-radio-button label="active"></el-radio-button>
          <el-radio-button label="failed"></el-radio-button>
          <el-radio-button label="cancelled"></el-radio-button>
          <el-radio-button label="all"></el-radio-button>
        </el-radio-group>

      </template>
    </reports-menu>


    <div class="flex flex-wrap overflow-hidden px-8 md:px-4 pt-4 d-reports tab-donations">

      <div class="w-4/5 xl:w-4/6 md:w-full pr-5 md:pr-0">
        <div class="d-block shadow-md rounded-md bg-white">
        <h3 class="title">Monthly Donations</h3>
        <div class="contacts-list campaign-donations-list">
          <div id="c-donations-table_wrapper">

            <el-table
                class="table-extendable"
                :class="{'table-lg-extend': !isScrollTop}"
                style = "width: 100%"
                :default-sort = "sorting"
                :data = "itemsDataPage"
                height="400"
                v-on:sort-change="sortChange"
            >
              <template  slot="empty">
                <div v-if="subscriptionsLoaded" class="empty-placeholder">
                  <img :src="require('../../assets/paceholders/33.svg')" alt="No results">
                  <h3>No Monthly Donations Yet</h3>
                </div>
                <div v-else slot="empty">Loading data...</div>
              </template>
              <el-table-column label="Date Created"
                               prop="created_at"
                               :sort-orders="['descending', 'ascending']"
                               sortable="custom"
                               width="150"
              >
                <template slot-scope="scope">
                  {{scope.row.created_at | dateFormat('MMM DD, YYYY')}}
                  <div class="info">{{scope.row.created_at | dateFormat('h:mma')}}</div>
                </template>
              </el-table-column>

              <el-table-column label="Name & Email"
                               prop="_donor_full_name"
                               sortable="custom"
                               :sort-orders="['ascending', 'descending']"
                               column-key="_donor_full_name"
                               min-width="300"
              >
                <template slot-scope="scope">
                  <div class="donor">
                    <span class="show-donor-info"
                          v-on:click.prevent="showDonorSidebar(scope.row.donor.uid)"
                    >{{scope.row.donor.first_name}} {{scope.row.donor.last_name}}</span>
                    <div class="info">{{scope.row.donor.email}}</div>
                  </div>
                </template>
              </el-table-column>

              <el-table-column label="Amount"
                               prop="amount"
                               sortable="custom"
                               :sort-orders="['descending', 'ascending']"
                               min-width="140"
              >
                <template slot-scope="scope">
                <span :class="{
                  'txt-orange': scope.row.status === 'failed',
                  'txt-red': scope.row.status === 'cancelled',
                  'txt-blue': scope.row.status === 'active',
                }"
                >${{scope.row.amount / 100 | formatMoney(0, 9)}}</span><sup>/mo</sup>
                  <div class="info">Per Month</div>

                </template>
              </el-table-column>

              <el-table-column label="# of Gifts"
                               prop="payments"
                               sortable="custom"
                               :sort-orders="['descending', 'ascending']"
                               min-width="110"
              >
                <template slot-scope="scope">
                  <span>{{scope.row.payments}}</span>
                  <div class="info">Gifts</div>
                </template>
              </el-table-column>

              <el-table-column label="Next Donation"
                               prop="next_payment"
                               sortable="custom"
                               :sort-orders="['descending', 'ascending']"
                               min-width="140"
              >
                <template slot-scope="scope">
                  <template v-if="scope.row.status === 'cancelled'">
                    <span>--</span>
                    <div class="info txt-red">Cancelled</div>
                  </template>
                  <template v-else-if="scope.row.status === 'failed'">
                    <span>--</span>
                    <div class="info txt-orange">Failed</div>
                  </template>
                  <template v-else>
                    <span>{{scope.row.next_payment | dateFormat('MMM DD, YYYY')}}</span>
                    <div class="info">Donates in <span class="txt-blue">{{daysToDonate(scope.row.next_payment)}}</span>
                      day{{daysToDonate(scope.row.next_payment) === 1 ? '' : 's'}}</div>

                  </template>
                </template>
              </el-table-column>

              <el-table-column label="Total Donated"
                               prop="total"
                               sortable="custom"
                               :sort-orders="['descending', 'ascending']"
                               min-width="140"
              >
                <template slot-scope="scope">
                  <span>${{scope.row.total / 100 | formatMoney(0, 9)}}</span>
                  <div class="info">Total Donated</div>
                </template>
              </el-table-column>

              <el-table-column label=""
                               width="75"
              >
                <template slot-scope="scope">

                  <el-dropdown trigger="click"
                               @command="handleCommand"
                  >
                    <span class="el-dropdown-link inline-block text-gray-500 text-xl rounded-full h-8 w-8 flex items-center justify-center hover:bg-gray-200">
                      <font-awesome-icon :icon="['far', 'ellipsis-v']"  />
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item :command="['edit', scope.row]">Edit Gift</el-dropdown-item>
                      <el-dropdown-item :command="['cancel', scope.row]">Cancel Gift</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>

                </template>
              </el-table-column>

            </el-table>
            <el-pagination
                class="text-right"
                background
                :current-page.sync="currentPage"
                layout="prev, pager, next"
                :page-size="paginationInfo.pageSize"
                :total="itemsData.length">
            </el-pagination>

          </div>
        </div>
      </div>
      </div>
      <div class="w-1/5 xl:w-2/6 md:w-full">
        <div v-if="analytics"
             class="d-block d-block-overview summary shadow-md rounded-md bg-white px-6 py-4">
          <h2>Summary</h2>

          <div class="welcome">Amount per Month</div>
          <div class="total">
            <i class="just-wrap">${{activeStatistic.amount / 100 | formatMoney}}</i><small>/mo</small>
          </div>
          <div class="welcome">All-Time Totals</div>
          <table class="table">
            <tbody>
            <tr>
              <td>Subscriptions</td>
              <td class="value">{{analytics.donors}}</td>
            </tr>
            <tr>
              <td>Total # of Gifts</td>
              <td class="value">{{analytics.payments.total}}</td>
            </tr>
            <tr>
              <td>Total Donated</td>
              <td class="value txt-blue">${{analytics.donated / 100 | formatMoney}}</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <donor-info v-if="showDonorInfo"
                :donor-id="showDonorId"
                v-on:close-info="showDonorInfo = false"
    ></donor-info>

    <modal v-if="cancelModal"
           v-on:close-modal="cancelModal = false;"
           :modal-name="'message-turn-off'">
      <div slot="header">
        <div class="info">Cancel Monthly Gift</div>
      </div>
      <div slot="body" class="desc">
        <h3 style="margin: 0;">{{ selectedDonation.donor.first_name }} {{ selectedDonation.donor.last_name }} -
          ${{ (selectedDonation.amount)/100 | formatMoney }}/month</h3>
        Are you sure you want to cancel this monthly gift?
        <br><br>
        <em>This monthly gift will no longer be donated moving forward</em>
      </div>
      <template slot="footer">
        <div>
          <a class="cancel"
             v-on:click.prevent="cancelModal = false"
             href="#">Don't Cancel</a>
        </div>
        <div>
          <button type="submit"
                  v-on:click.prevent="deleteMonthly(selectedDonation);cancelModal = false; "
                  class="btn btn-sm btn-add-to-message btn-delete"
          >Cancel Monthly Gift
          </button>
        </div>
      </template>
    </modal>

    <modal v-if="editModal"
           v-on:close-modal="editModal = false;"
           class="list-modal-wrap"
           :modal-name="'message-turn-off'">

      <div slot="header">
        <div class="info">Edit Monthly Gift</div>
      </div>
      <div slot="body" class="desc">
        <div class="input-control form-item">
          <label>Full Name</label>
          <div class="name"><b>{{selectedDonation.donor.first_name}} {{selectedDonation.donor.last_name}}</b></div>
        </div>

        <div class="input-control form-item">
          <label>Amount</label>
          <div class="name"><b>${{selectedDonation.total/100 | formatMoney}} / month</b></div>
        </div>

        <div v-if="allCampaigns && allCampaigns.length>0" class="input-control">
          <label for="d-method">Campaign</label>
          <select
              id="d-method"
              class="form-control"
              v-model="editParams.campaign_id"
          >
            <option :value="null">Area of Greatest Need</option>
            <option v-for="campaign in allCampaigns"
                    :key="campaign.id"
                    :value="campaign.id">{{campaign.name}}</option>
          </select>
        </div>

        <div class="input-control">
          <span v-if="editParams.public" class="limit">Public</span>
          <span v-else class="limit limit-red">Private</span>
          <label for="note-text">Note/Comment</label>
          <textarea class="input-sm list-add-text "
                    id="note-text"
                    style="height: auto"
                    v-model="editParams.message"
                    rows="3"
                    placeholder="Note/Comment"></textarea>
        </div>

        <label class="form-switch">
          <input
              type="checkbox"
              v-model="editParams.public"
          > Display this note Publicly
        </label>

      </div>
      <template slot="footer">
        <div>
          <a v-on:click.prevent="editModal = false"
             href="#" class="cancel">Cancel</a>
        </div>
        <div>
          <button type="submit"
                  v-on:click.prevent="editDonation(selectedDonation);editModal = false; "
                  class="btn btn-sm btn-add-to-message"
          >Save Changes
          </button>
        </div>
      </template>
    </modal>

  </div>
</template>

<script>
import {formatMoney} from '@/utils/utils';
import ReportsMenu from './menu.vue';
import DonorInfo from '../Parts/DonorInfo.vue';
import Modal from '../Modal/index.vue';
import reportsMixin from './reports-mixin';
import reportsMenuMixin from './reports-menu-mixin';
import scrollInfoMixin from '../../mixins/scroll-info-mixin';

import dataTableMixin from '../Parts/data-table-mixin';
import {capitalize} from "@/utils/utils";
import {mapState} from "vuex";
import store from "@/store";

  const moment = require('moment');

  export default {
    name: 'Reports',
    mixins: [reportsMenuMixin, reportsMixin, dataTableMixin, scrollInfoMixin],
    components: {
      ReportsMenu,
      DonorInfo,
      Modal,
    },
    filters: {
      capitalize(value) {
        if (!value) return '';
        value = value.toString();
        return value.charAt(0).toUpperCase() + value.slice(1);
      },
    },
    metaInfo: {
      title: 'Reports - Monthly Donations',
    },
    mounted() {
      this.initScrollInfo(['.el-table--scrollable-y','.el-table__body-wrapper', '.content']);

      this.updateMonthly();
    },
    methods: {
      handleCommand([command, payload]) {
        switch (command){
          case 'edit':
            this.openEditModal(payload)
            break
          case 'cancel':
            this.selectedDonation = payload;
            this.cancelModal = true;
            break
        }
      },
      sortChange(sorting) {
        this.sorting = sorting
      },
      openEditModal(donationInfo){
        this.selectedDonation = donationInfo;
        this.editParams.message = '';
        this.editParams.public = false;

        this.$store.dispatch('monthlyDonations/fetchOneDonation', {
          charityId: this.activeCharityId,
          subscriptionId: donationInfo.id,
        })
            .then((donationInfo) => {
              this.editParams.campaign_id = donationInfo.subscription.campaign_id;

              if (donationInfo.subscription && donationInfo.subscription.metadata && donationInfo.subscription.metadata.note) {

                this.editParams.message = donationInfo.subscription.metadata.note.message;
                this.editParams.public = donationInfo.subscription.metadata.note.public;

              }
              this.editModal = true;
            })
            .catch(err => alert(err));

      },
      editDonation(donationInfo){

        let editParams = {
          "campaign_id": this.editParams.campaign_id
        };
        if (this.editParams.message) {
          editParams['note'] = {
            "message": this.editParams.message,
            "public": this.editParams.public
          };
        } else {
          editParams['note'] = null;
        }

        this.$store.dispatch('monthlyDonations/editDonation', {
          charityId: this.activeCharityId,
          subscriptionId: donationInfo.id,
          params: editParams,
        })
            .then(() => {
              this.$message('Monthly Gift Updated')
              this.updateMonthly();
            })
            .catch(err => alert(err));
      },
      deleteMonthly(donationInfo){
        this.$store.dispatch('monthlyDonations/cancelDonation', {
          charityId: this.activeCharityId,
          subscriptionId: donationInfo.id,
        })
            .then(() => {
              this.$message('Monthly Gift Canceled')
              this.updateMonthly();
            })
            .catch(err => alert(err));
      },
      daysToDonate(data){
        const dt = moment(data);

        let days = Math.ceil(moment.duration(dt.diff(moment())).asDays());
        return days < 1 ? 1 : days;
      },
      download(type) {

        const title = `Monthly Donations ${this.period.start.format('MMM D YYYY')} - ${this.period.end.format(
          'MMM D YYYY')}`;

        const header = [
          type === 'pdf' ? 'Date' : 'Date Created',
          type === 'pdf' ? 'Time' : 'Time Created',
          'First Name', 'Last Name', 'Email', 'Status', 'Amount',
          type === 'pdf' ? 'Gifts' : '# of Gifts',
          'Next Donation',
          type === 'pdf' ? 'Total' : 'Total Donated',
        ];

        const body = this.itemsDataSorted.map(item => {
          const dt = moment(item.created_at);
          return [
            dt.format('MMM D, YYYY'),
            dt.format('h:mma'),
            item.donor.first_name,
            item.donor.last_name,
            item.donor.email,
            capitalize(item.status),
            '$' + formatMoney(item.amount / 100, 2, 9),
            item.payments,
            moment(item.next_payment).format('MMM DD, YYYY'),
            '$' + formatMoney(item.total / 100, 2, 9),
          ];
        });

        this.exportData(type, title, header, body);
      },
      updateMonthly() {
        this.$store.dispatch('campaigns/updateCampaigns', {charityId: store.state.auth.activeCharityId, force: true});

        this.$store.dispatch('monthlyDonations/fetchAllDonations', {charityId: this.activeCharityId})
            .then(info => {
              this.subscriptionsLoaded = true;
              this.subscriptions = info.subscriptions;
              this.analytics = info.analytics;
            });
      },
    },
    computed:{
      ...mapState({
        allCampaigns: state => state.campaigns.allCampaigns,
        activeCharityId: state => state.auth.activeCharityId,
      }),

      activeStatistic(){
        const statistic = {
          count: 0,
          amount: 0
        };

        if(!this.subscriptionsLoaded){
          return statistic;
        }

        let subscriptions =  [...this.subscriptions];
        const activeSubscriptions = subscriptions.map(d => ({
          ...d,
          status: d.funding_source.error ? 'failed' : (d.next_payment ? 'active' : 'cancelled')
        })).filter(d => {
          return 'active' === d.status;
        });

        statistic.count = activeSubscriptions.length;
        statistic.amount = activeSubscriptions.reduce((r, s) => r + Number(s.amount), 0);
        return statistic;
      },
      itemsData() {
        if(!this.subscriptionsLoaded){
          return [];
        }

        let subscriptions =  [...this.subscriptions];
        if (this.searchDonorsName) {
          const re = new RegExp(this.searchDonorsName, 'ig');
          subscriptions = subscriptions.filter(d => `${d.donor.first_name} ${d.donor.last_name}`.search(re) !== -1);
        }

        return subscriptions.map(d => ({
          ...d,
          amount: Number(d.amount),
          status: d.funding_source.error ? 'failed' : (d.next_payment ? 'active' : 'cancelled')
        })).filter(d => {
          if(this.selectedFilter === 'all'){
            return true
          }
          return this.selectedFilter === d.status;
        });
      }
    },
    watch: {
      'activeCharityId'() {
        this.updateMonthly();
      },
    },
    data() {
      return {
        showDonorInfo: false,
        showDonorId: null,
        searchDonorsName: '',
        analytics: null,
        subscriptions: [],
        subscriptionsLoaded: false,
        testWidth: 200,
        selectedFilter: 'active',

        cancelModal: false,
        editModal: false,

        selectedDonation: null,
        editParams: {
          campaign_id: null,
          message: '',
          public: false
        },

      };
    },
  };
</script>
